import React, { useState } from 'react';
import { ConfigProvider, Menu, Checkbox } from 'antd';

const AccountList = ({ accountDetails, setAccountDetails, label }) => {
  const [allSelected, setAllSelected] = useState(true);

  const onMainCheckboxClick = (e) => {
    e.stopPropagation();
    const tempAllSelected = !allSelected;
    const tempCustomerList = [...accountDetails];
    tempCustomerList.forEach((acc) => (acc.isSelected = tempAllSelected));
    if (!tempAllSelected) {
      // if all is unselected ,select 1st account.
      tempCustomerList[0].isSelected = true;
    }
    setAllSelected(tempAllSelected);
    setAccountDetails(tempCustomerList);
  };

  const items = [
    {
      key: label,
      label,
      icon: <Checkbox checked={allSelected} onClick={onMainCheckboxClick} />,
      children: accountDetails.map((item) => {
        return {
          key: item.customerId,
          // label: item.customerName.split('.')[1],
          label: item.customerName,
          icon: <Checkbox checked={item.isSelected} />,
          selectable: false,
        };
      }),
    },
  ];

  const onSelect = (e) => {
    const tempCustomerList = [...accountDetails];
    const ind = tempCustomerList.findIndex((acc) => String(acc.customerId) === String(e.key));
    tempCustomerList[ind].isSelected = !tempCustomerList[ind]?.isSelected;

    const atLeastOneSelected = tempCustomerList.reduce(
      (oneSelected, cust) => cust.isSelected || oneSelected,
      false,
    );
    if (!atLeastOneSelected) {
      tempCustomerList[0].isSelected = true;
    }

    setAccountDetails(tempCustomerList);
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            colorItemBgSelected: 'rgba(0, 0, 0, 0.02)',
            colorItemBg: '#f5f5f5',
          },
        },
      }}
    >
      <Menu
        onClick={onSelect}
        mode="inline"
        defaultOpenKeys={[label]}
        style={{ height: '100%', fontSize: '14px' }}
        items={items}
        selectedKeys={accountDetails
          .filter((item) => item.isSelected)
          .map((item) => item.customerId)}
        multiple
      />
    </ConfigProvider>
  );
};
export default AccountList;
